import { createReduxActionTypes } from '../../../utils/actionFactory';

const SET_ACCOUNTS = 'SET_ACCOUNTS';
const RESET_ACCOUNTS = 'RESET_ACCOUNTS';
const SET_COLUMNS = 'SET_COLUMNS';
const SET_SELECTED_ACCOUNT = 'SET_SELECTED_ACCOUNT';

export const actionTypes = createReduxActionTypes('Ivoices', [
  SET_ACCOUNTS,
  RESET_ACCOUNTS,
  SET_COLUMNS,
  SET_SELECTED_ACCOUNT
]);

const DEFAULT_STATE = {
  accounts: [],
  selectOptions: [],
  selectedAccount: {},
  columns: []
};

export const reducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case actionTypes[SET_ACCOUNTS]: {
      const { accounts, selectOptions, selectedAccount } = action;
      return { ...state, accounts, selectOptions, selectedAccount };
    }
    case actionTypes[SET_COLUMNS]: {
      return { ...state, columns: [...action.columns] };
    }
    case actionTypes[SET_SELECTED_ACCOUNT]: {
      const { selectedAccount } = action;
      return {
        ...state,
        selectedAccount
      };
    }
    case actionTypes[RESET_ACCOUNTS]: {
      return { ...DEFAULT_STATE };
    }
    default:
      return state;
  }
};

export const actions = {
  setAccounts: (accounts, selectOptions, selectedAccount) => ({
    type: actionTypes[SET_ACCOUNTS],
    accounts,
    selectOptions,
    selectedAccount
  }),
  setColumns: columns => ({
    type: actionTypes[SET_COLUMNS],
    columns
  }),
  setSelectedAccount: selectedAccount => ({
    type: actionTypes[SET_SELECTED_ACCOUNT],
    selectedAccount
  }),
  resetAccounts: () => ({ type: actionTypes[RESET_ACCOUNTS] })
};
